(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.cartReady === 'true') return;
    drawer.dataset.cartReady = 'true';
    const root = drawer.dataset.rootUrl || '/';
    const itemsNode = drawer.querySelector('[data-cart-items]');
    const footer = drawer.querySelector('[data-cart-footer]');
    const totalNode = drawer.querySelector('[data-cart-total]');
    const statusNode = drawer.querySelector('[data-cart-status]');
    const panel = drawer.querySelector('.pk-cart-drawer__panel');
    const money = (cents) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(cents / 100);

    const closeDrawer = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };

    const openDrawer = () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      window.setTimeout(() => panel?.querySelector('[data-cart-close]')?.focus(), 250);
    };

    const renderCart = (cart) => {
      document.querySelectorAll('.pk-cart-count').forEach((count) => count.textContent = cart.item_count);
      itemsNode.replaceChildren();
      if (!cart.items.length) {
        const empty = document.createElement('p');
        empty.className = 'pk-cart-drawer__empty';
        empty.textContent = 'Tu carrito está vacío. Explora los diseños y elige tu próximo favorito.';
        itemsNode.append(empty);
        footer.hidden = true;
        return;
      }

      cart.items.forEach((item) => {
        const article = document.createElement('article');
        article.className = 'pk-cart-drawer__item';
        const mediaLink = document.createElement('a');
        mediaLink.className = 'pk-cart-drawer__item-media';
        mediaLink.href = item.url;
        if (item.image) {
          const image = document.createElement('img');
          image.src = item.image;
          image.alt = item.product_title;
          image.loading = 'lazy';
          mediaLink.append(image);
        }
        const content = document.createElement('div');
        content.className = 'pk-cart-drawer__item-content';
        const title = document.createElement('a');
        title.href = item.url;
        title.textContent = item.product_title;
        const variant = document.createElement('small');
        variant.textContent = `${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : ''}Cantidad: ${item.quantity}`;
        const price = document.createElement('p');
        price.textContent = money(item.final_line_price);
        content.append(title, variant, price);
        article.append(mediaLink, content);
        itemsNode.append(article);
      });
      totalNode.textContent = money(cart.total_price);
      footer.hidden = false;
    };

    const refreshCart = async () => {
      const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('No pudimos cargar el carrito.');
      const cart = await response.json();
      renderCart(cart);
      return cart;
    };

    document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', async (event) => {
      event.preventDefault();
      statusNode.textContent = '';
      openDrawer();
      try { await refreshCart(); } catch (error) { statusNode.textContent = error.message; }
    }));
    drawer.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });

    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form[action*="/cart/add"]');
      const submitter = event.submitter;
      if (!form || !submitter?.matches('[data-oversize-submit], [data-mobile-product-submit]')) return;
      event.preventDefault();
      submitter.setAttribute('aria-busy', 'true');
      submitter.disabled = true;
      statusNode.textContent = '';
      try {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || 'No pudimos agregar este producto.');
        }
        await refreshCart();
        statusNode.textContent = 'Producto agregado correctamente.';
        openDrawer();
      } catch (error) {
        statusNode.textContent = error.message;
        openDrawer();
      } finally {
        submitter.removeAttribute('aria-busy');
        submitter.disabled = false;
      }
    });
  })();

  (() => {
    const search = document.querySelector('[data-predictive-search]');
    if (!search || search.dataset.predictiveReady === 'true') return;
    search.dataset.predictiveReady = 'true';

    const root = search.dataset.rootUrl || '/';
    const input = search.querySelector('[data-predictive-input]');
    const results = search.querySelector('[data-predictive-results]');
    const openButtons = document.querySelectorAll('[data-predictive-open]');
    let timer;
    let request;

    const setMessage = (className, message) => {
      const paragraph = document.createElement('p');
      paragraph.className = className;
      paragraph.textContent = message;
      results.replaceChildren(paragraph);
    };

    const closeSearch = () => {
      request?.abort();
      search.classList.remove('is-open');
      search.setAttribute('aria-hidden', 'true');
      openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'));
      document.documentElement.style.overflow = '';
    };

    const openSearch = () => {
      search.classList.add('is-open');
      search.setAttribute('aria-hidden', 'false');
      openButtons.forEach((button) => button.setAttribute('aria-expanded', 'true'));
      document.documentElement.style.overflow = 'hidden';
      window.setTimeout(() => input?.focus(), 220);
    };

    const fetchResults = async (query) => {
      request?.abort();
      request = new AbortController();
      results.setAttribute('aria-busy', 'true');
      const url = `${root}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&section_id=pulsokage-predictive-search`;
      try {
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error('predictive-search');
        const text = await response.text();
        const html = document.createElement('div');
        html.innerHTML = text;
        const source = html.querySelector('#shopify-section-pulsokage-predictive-search');
        if (source?.innerHTML.trim()) {
          results.innerHTML = source.innerHTML;
        } else {
          setMessage('pk-predictive__empty', search.dataset.empty);
        }
      } catch (error) {
        if (error.name !== 'AbortError') setMessage('pk-predictive__empty', search.dataset.error);
      } finally {
        results.removeAttribute('aria-busy');
      }
    };

    openButtons.forEach((button) => button.addEventListener('click', openSearch));
    search.querySelectorAll('[data-predictive-close]').forEach((button) => button.addEventListener('click', closeSearch));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && search.classList.contains('is-open')) closeSearch(); });
    input?.addEventListener('input', (event) => {
      window.clearTimeout(timer);
      const query = event.currentTarget.value.trim();
      if (query.length < 2) {
        request?.abort();
        setMessage('pk-predictive__hint', search.dataset.hint);
        return;
      }
      timer = window.setTimeout(() => fetchResults(query), 220);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!event.target.matches('[data-variant-select]')) return;
    const option = event.target.selectedOptions[0];
    const section = event.target.closest('[data-section-id]');
    const price = section.querySelector('[data-product-price]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsokage-anime-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-pk-collection-showcase]').forEach((section) => {
    if (section.dataset.showcaseReady === 'true') return;
    section.dataset.showcaseReady = 'true';

    const cards = Array.from(section.querySelectorAll('[data-showcase-card]'));
    const previous = section.querySelector('[data-showcase-prev]');
    const next = section.querySelector('[data-showcase-next]');
    const stage = section.querySelector('.pk-collection-showcase__stage');
    const desktop = window.matchMedia('(min-width: 990px)');
    let active = 0;
    let touchStartX = 0;
    let suppressClick = false;

    const render = () => {
      cards.forEach((card, index) => {
        let position = index - active;
        if (position > cards.length / 2) position -= cards.length;
        if (position < cards.length / -2) position += cards.length;
        card.dataset.position = String(position);
        const visibleRange = desktop.matches ? 2 : 1;
        const hidden = Math.abs(position) > visibleRange;
        card.setAttribute('aria-hidden', hidden ? 'true' : 'false');
        card.tabIndex = position === 0 ? 0 : -1;
      });
    };

    const move = (direction) => {
      active = (active + direction + cards.length) % cards.length;
      render();
    };

    cards.forEach((card, index) => {
      card.addEventListener('click', (event) => {
        if (suppressClick) {
          event.preventDefault();
          return;
        }
        if (index === active) return;
        event.preventDefault();
        active = index;
        render();
      });
    });

    previous?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
    stage?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') move(-1);
      if (event.key === 'ArrowRight') move(1);
    });
    stage?.addEventListener('touchstart', (event) => {
      touchStartX = event.changedTouches[0]?.clientX || 0;
    }, { passive: true });
    stage?.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0]?.clientX || 0;
      const distance = touchEndX - touchStartX;
      if (Math.abs(distance) < 45) return;
      event.preventDefault();
      suppressClick = true;
      move(distance < 0 ? 1 : -1);
      window.setTimeout(() => { suppressClick = false; }, 350);
    }, { passive: false });
    desktop.addEventListener('change', render);
    render();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsokage-cart-recommendations"]) return;
  try {
    
  document.querySelectorAll('[data-pk-cart-recommendations]').forEach((section) => {
    if (section.dataset.recommendationsReady === 'true') return;
    section.dataset.recommendationsReady = 'true';

    const loadRecommendations = () => {
      const url = section.dataset.url;
      if (!url) return;
      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const source = html.querySelector('[data-pk-cart-recommendations]');
          if (source && source.innerHTML.trim()) {
            section.innerHTML = source.innerHTML;
          } else {
            section.remove();
          }
        })
        .catch(() => section.remove());
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        loadRecommendations();
      }, { rootMargin: '0px 0px 300px 0px' });
      observer.observe(section);
    } else {
      loadRecommendations();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsokage-design-showcase"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-design-showcase]').forEach((section) => {
    if (section.dataset.showcaseReady === 'true') return;
    section.dataset.showcaseReady = 'true';
    const buttons = Array.from(section.querySelectorAll('[data-showcase-button]'));
    const images = Array.from(section.querySelectorAll('[data-showcase-image]'));
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const target = button.dataset.showcaseButton;
        buttons.forEach((item) => item.setAttribute('aria-pressed', item === button ? 'true' : 'false'));
        images.forEach((image) => image.classList.toggle('is-active', image.dataset.showcaseImage === target));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsokage-header-premium"]) return;
  try {
    
  (() => {
    const desktopDropdowns = () => [...document.querySelectorAll('[data-desktop-dropdown]')];
    const mobileMenu = () => document.querySelector('[data-mobile-menu]');
    const syncExpanded = (details) => details.querySelector(':scope > summary')?.setAttribute('aria-expanded', String(details.open));

    // Delegation keeps navigation working after the theme editor re-renders the section.
    document.addEventListener('toggle', (event) => {
      const details = event.target;
      if (!(details instanceof HTMLElement) || !details.matches('[data-desktop-dropdown], [data-mobile-accordion], [data-mobile-menu]')) return;
      syncExpanded(details);
      if (!details.open) return;
      const selector = details.matches('[data-desktop-dropdown]') ? '[data-desktop-dropdown]' : details.matches('[data-mobile-accordion]') ? '[data-mobile-accordion]' : null;
      if (selector) details.closest('nav')?.querySelectorAll(selector).forEach((other) => { if (other !== details && other.open) other.open = false; });
    }, true);

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-desktop-dropdown]')) desktopDropdowns().forEach((details) => { details.open = false; });
      const anchor = event.target.closest('[data-shop-by-product-link]');
      if (!anchor) return;
      const target = document.getElementById('ver-por-producto');
      if (!target) return;
      event.preventDefault();
      const menu = mobileMenu();
      if (menu) menu.open = false;
      target.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', '#ver-por-producto');
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const activeDropdown = desktopDropdowns().find((details) => details.open);
      if (activeDropdown) { activeDropdown.open = false; activeDropdown.querySelector('summary')?.focus(); }
      const menu = mobileMenu();
      if (menu?.open) { menu.open = false; menu.querySelector(':scope > summary')?.focus(); }
    });
    document.addEventListener('shopify:block:select', (event) => {
      const section = event.target.closest('.shopify-section');
      if (!section || !event.detail?.blockId) return;
      const desktop = matchMedia('(min-width: 1100px)').matches;
      const navigation = section.querySelector(desktop ? '.pk-premium-header__menu' : '.pk-premium-mobile-nav');
      const selected = [...(navigation?.querySelectorAll('[data-collection-block]') || [])].find((item) => item.dataset.collectionBlock === event.detail.blockId);
      if (!selected) return;
      if (!desktop) navigation.open = true;
      const group = selected.closest('details');
      if (group) group.open = true;
      selected.scrollIntoView({ block: 'nearest', inline: 'nearest' });
    });
  })();

  (() => {
    const drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.cartReady === 'true') return;
    drawer.dataset.cartReady = 'true';
    const root = drawer.dataset.rootUrl || '/';
    const itemsNode = drawer.querySelector('[data-cart-items]');
    const footer = drawer.querySelector('[data-cart-footer]');
    const totalNode = drawer.querySelector('[data-cart-total]');
    const statusNode = drawer.querySelector('[data-cart-status]');
    const panel = drawer.querySelector('.pk-cart-drawer__panel');
    const money = (cents) => new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(cents / 100);
    const closeDrawer = () => { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; };
    const openDrawer = () => { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; setTimeout(() => panel?.querySelector('[data-cart-close]')?.focus(), 220); };
    const renderCart = (cart) => {
      document.querySelectorAll('.pk-cart-count').forEach((count) => count.textContent = cart.item_count);
      itemsNode.replaceChildren();
      if (!cart.items.length) { const empty = document.createElement('p'); empty.className = 'pk-cart-drawer__empty'; empty.textContent = 'Tu carrito está vacío. Explora los diseños y elige tu próximo favorito.'; itemsNode.append(empty); footer.hidden = true; return; }
      cart.items.forEach((item) => {
        const article = document.createElement('article'); article.className = 'pk-cart-drawer__item';
        const mediaLink = document.createElement('a'); mediaLink.className = 'pk-cart-drawer__item-media'; mediaLink.href = item.url;
        if (item.image) { const image = document.createElement('img'); image.src = item.image; image.alt = item.product_title; image.loading = 'lazy'; mediaLink.append(image); }
        const content = document.createElement('div'); content.className = 'pk-cart-drawer__item-content';
        const title = document.createElement('a'); title.href = item.url; title.textContent = item.product_title;
        const variant = document.createElement('small'); variant.textContent = `${item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title + ' · ' : ''}Cantidad: ${item.quantity}`;
        const price = document.createElement('p'); price.textContent = money(item.final_line_price);
        content.append(title, variant, price); article.append(mediaLink, content); itemsNode.append(article);
      });
      totalNode.textContent = money(cart.total_price); footer.hidden = false;
    };
    const refreshCart = async () => { const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }); if (!response.ok) throw new Error('No pudimos cargar el carrito.'); const cart = await response.json(); renderCart(cart); return cart; };
    document.querySelectorAll('[data-cart-open]').forEach((button) => button.addEventListener('click', async (event) => { event.preventDefault(); statusNode.textContent = ''; openDrawer(); try { await refreshCart(); } catch (error) { statusNode.textContent = error.message; } }));
    drawer.querySelectorAll('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer(); });
    document.addEventListener('submit', async (event) => {
      const form = event.target.closest('form[action*="/cart/add"]'); const submitter = event.submitter;
      if (!form || !submitter?.matches('[data-oversize-submit], [data-mobile-product-submit]')) return;
      event.preventDefault(); submitter.setAttribute('aria-busy', 'true'); submitter.disabled = true; statusNode.textContent = '';
      try { const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) }); if (!response.ok) { const error = await response.json(); throw new Error(error.description || 'No pudimos agregar este producto.'); } await refreshCart(); statusNode.textContent = 'Producto agregado correctamente.'; openDrawer(); }
      catch (error) { statusNode.textContent = error.message; openDrawer(); }
      finally { submitter.removeAttribute('aria-busy'); submitter.disabled = false; }
    });
  })();

  (() => {
    const search = document.querySelector('[data-predictive-search]');
    if (!search || search.dataset.predictiveReady === 'true') return;
    search.dataset.predictiveReady = 'true';
    const root = search.dataset.rootUrl || '/'; const input = search.querySelector('[data-predictive-input]'); const results = search.querySelector('[data-predictive-results]'); const openButtons = document.querySelectorAll('[data-predictive-open]');
    let timer; let request;
    const setMessage = (message) => { const paragraph = document.createElement('p'); paragraph.textContent = message; results.replaceChildren(paragraph); };
    const closeSearch = () => { request?.abort(); search.classList.remove('is-open'); search.setAttribute('aria-hidden', 'true'); openButtons.forEach((button) => button.setAttribute('aria-expanded', 'false')); document.documentElement.style.overflow = ''; };
    const openSearch = () => { search.classList.add('is-open'); search.setAttribute('aria-hidden', 'false'); openButtons.forEach((button) => button.setAttribute('aria-expanded', 'true')); document.documentElement.style.overflow = 'hidden'; setTimeout(() => input?.focus(), 220); };
    const fetchResults = async (query) => {
      request?.abort(); request = new AbortController(); results.setAttribute('aria-busy', 'true');
      const url = `${root}search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last&section_id=pulsokage-predictive-search`;
      try { const response = await fetch(url, { signal: request.signal }); if (!response.ok) throw new Error('predictive-search'); const responseText = await response.text(); const html = document.createElement('div'); html.innerHTML = responseText; const source = html.querySelector('#shopify-section-pulsokage-predictive-search'); source?.innerHTML.trim() ? (results.innerHTML = source.innerHTML) : setMessage(search.dataset.empty); }
      catch (error) { if (error.name !== 'AbortError') setMessage(search.dataset.error); }
      finally { results.removeAttribute('aria-busy'); }
    };
    openButtons.forEach((button) => button.addEventListener('click', openSearch)); search.querySelectorAll('[data-predictive-close]').forEach((button) => button.addEventListener('click', closeSearch));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && search.classList.contains('is-open')) closeSearch(); });
    input?.addEventListener('input', (event) => { clearTimeout(timer); const query = event.currentTarget.value.trim(); if (query.length < 2) { request?.abort(); setMessage(search.dataset.hint); return; } timer = setTimeout(() => fetchResults(query), 220); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsokage-main-collection"]) return;
  try {
    
  (() => {
    const initializeCollection = (section) => {
      if (section.dataset.collectionReady === 'true') return;
      section.dataset.collectionReady = 'true';
      const panel = section.querySelector('[data-filter-panel]');
      const backdrop = section.querySelector('[data-filter-backdrop]');
      const setFilters = (open) => {
        panel?.classList.toggle('is-open', open);
        backdrop?.classList.toggle('is-open', open);
        document.documentElement.style.overflow = open ? 'hidden' : '';
      };
      section.querySelector('[data-filter-open]')?.addEventListener('click', () => setFilters(true));
      section.querySelectorAll('[data-filter-close]').forEach((button) => button.addEventListener('click', () => setFilters(false)));
      section.querySelector('[data-collection-sort]')?.addEventListener('change', (event) => event.currentTarget.form.submit());
    };
    document.querySelectorAll('[data-collection-section]').forEach(initializeCollection);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('[data-collection-section]').forEach(initializeCollection);
    });
    document.addEventListener('shopify:section:unload', (event) => {
      if (event.target.querySelector('[data-filter-panel].is-open')) document.documentElement.style.overflow = '';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsokage-product-oversize"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-oversize-product]').forEach((section) => {
    if (section.dataset.oversizeReady === 'true') return;
    section.dataset.oversizeReady = 'true';

    const variantsNode = section.querySelector('[data-oversize-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const groups = Array.from(section.querySelectorAll('[data-option-group]'));
    const variantInput = section.querySelector('[data-oversize-variant-id]');
    const price = section.querySelector('[data-oversize-price]');
    const submit = section.querySelector('[data-oversize-submit]');
    const submitText = section.querySelector('[data-oversize-submit-text]');
    const submitPrice = section.querySelector('[data-oversize-submit-price]');
    const submitAvailableLabel = submit?.dataset.availableLabel || 'Agregar al carrito';
    const submitUnavailableLabel = submit?.dataset.unavailableLabel || 'Agotado';
    const submitShowsPrice = submit?.dataset.showPrice !== 'false';
    const mobilePrice = section.querySelector('[data-mobile-product-price]');
    const mobileSubmit = section.querySelector('[data-mobile-product-submit]');
    const mobileSubmitText = section.querySelector('[data-mobile-product-submit-text]');
    const mobileAvailableLabel = mobileSubmit?.dataset.availableLabel || submitAvailableLabel;
    const mobileUnavailableLabel = mobileSubmit?.dataset.unavailableLabel || submitUnavailableLabel;
    const gallery = section.querySelector('[data-product-gallery]');
    const thumbnails = Array.from(section.querySelectorAll('[data-gallery-thumbnail]'));
    const mainImage = section.querySelector('.pk-oversize-product__media > img');
    const mainMedia = section.querySelector('.pk-oversize-product__media');
    const galleryCount = section.querySelector('[data-gallery-count]');
    const zoomButton = section.querySelector('[data-gallery-zoom]');
    const zoomDialog = section.querySelector('[data-gallery-dialog]');
    const zoomImage = section.querySelector('[data-gallery-zoom-image]');
    let activeImage = Math.max(0, thumbnails.findIndex((thumbnail) => thumbnail.classList.contains('is-active')));

    const preloadImage = (thumbnail) => {
      if (!thumbnail || thumbnail.dataset.imagePreloaded === 'true') return;
      const image = new Image();
      image.sizes = mainImage?.sizes || '(min-width: 990px) 48vw, 94vw';
      image.srcset = thumbnail.dataset.imageSrcset || '';
      image.src = thumbnail.dataset.imageSrc;
      thumbnail.dataset.imagePreloaded = 'true';
    };

    const activateImage = (index) => {
      if (!thumbnails.length || !mainImage) return;
      activeImage = (index + thumbnails.length) % thumbnails.length;
      const thumbnail = thumbnails[activeImage];
      preloadImage(thumbnail);
      mainImage.srcset = thumbnail.dataset.imageSrcset;
      mainImage.src = thumbnail.dataset.imageSrc;
      mainImage.alt = thumbnail.dataset.imageAlt;
      if (zoomImage) {
        zoomImage.srcset = thumbnail.dataset.imageSrcset;
        zoomImage.src = thumbnail.dataset.imageSrc;
        zoomImage.alt = thumbnail.dataset.imageAlt;
      }
      thumbnails.forEach((item, itemIndex) => {
        const selected = itemIndex === activeImage;
        item.classList.toggle('is-active', selected);
        item.setAttribute('aria-current', selected ? 'true' : 'false');
      });
      thumbnail.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      if (galleryCount) galleryCount.textContent = `${activeImage + 1} / ${thumbnails.length}`;
    };

    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('pointerenter', () => preloadImage(thumbnail), { once: true });
      thumbnail.addEventListener('pointerdown', () => preloadImage(thumbnail), { once: true });
      thumbnail.addEventListener('click', () => activateImage(index));
    });
    const preloadGallery = () => thumbnails.forEach(preloadImage);
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preloadGallery, { timeout: 1500 });
    } else {
      window.setTimeout(preloadGallery, 250);
    }
    gallery?.querySelector('[data-gallery-previous]')?.addEventListener('click', () => activateImage(activeImage - 1));
    gallery?.querySelector('[data-gallery-next]')?.addEventListener('click', () => activateImage(activeImage + 1));
    zoomButton?.addEventListener('click', () => zoomDialog?.showModal());
    zoomDialog?.querySelector('[data-gallery-close]')?.addEventListener('click', () => zoomDialog.close());
    zoomDialog?.addEventListener('click', (event) => {
      if (event.target === zoomDialog) zoomDialog.close();
    });
    const sizeGuideDialog = section.querySelector('[data-size-guide-dialog]');
    const sizeGuideOpenButton = section.querySelector('[data-size-guide-open]');
    const sizeGuideCloseButton = section.querySelector('[data-size-guide-close]');
    const sizeGuideTabButtons = Array.from(section.querySelectorAll('[data-size-guide-tab]'));
    const sizeGuidePanels = Array.from(section.querySelectorAll('[data-size-guide-panel]'));
    const sizeGuideUnitButtons = Array.from(section.querySelectorAll('[data-size-guide-unit]'));
    const sizeGuideValues = Array.from(section.querySelectorAll('[data-size-guide-value]'));
    const sizeGuideCellUnits = Array.from(section.querySelectorAll('[data-size-guide-unit-cell]'));
    const sizeGuideToleranceValue = section.querySelector('[data-size-guide-tolerance-value]');
    const sizeGuideUnitHeading = section.querySelector('[data-size-guide-unit-heading]');
    const sizeGuideUnitNote = section.querySelector('[data-size-guide-unit-note]');
    const formatMeasurement = (value, decimals) => value.toFixed(decimals).replace('.', ',');
    const setSizeGuideUnit = (unit) => {
      sizeGuideUnitButtons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.sizeGuideUnit === unit)));
      sizeGuideValues.forEach((node) => {
        const centimeters = Number.parseFloat((node.dataset.cm || '').replace(',', '.'));
        if (!Number.isFinite(centimeters)) return;
        node.textContent = unit === 'in' ? formatMeasurement(centimeters / 2.54, 1) : formatMeasurement(centimeters, Number.isInteger(centimeters) ? 0 : 1);
      });
      sizeGuideCellUnits.forEach((node) => { node.textContent = unit === 'in' ? 'pulg.' : 'cm'; });
      const tolerance = Number.parseFloat(sizeGuideDialog?.dataset.toleranceCm || '0');
      if (sizeGuideToleranceValue && Number.isFinite(tolerance)) {
        sizeGuideToleranceValue.textContent = unit === 'in' ? formatMeasurement(tolerance / 2.54, 1) : formatMeasurement(tolerance, Number.isInteger(tolerance) ? 0 : 1);
      }
      if (sizeGuideUnitHeading) sizeGuideUnitHeading.textContent = unit === 'in' ? 'PULG.' : 'CM';
      if (sizeGuideUnitNote) sizeGuideUnitNote.textContent = unit === 'in' ? 'pulg' : 'cm';
    };
    const setSizeGuideTab = (tabName, moveFocus = false) => {
      sizeGuideTabButtons.forEach((button) => {
        const selected = button.dataset.sizeGuideTab === tabName;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
        if (selected && moveFocus) button.focus();
      });
      sizeGuidePanels.forEach((panel) => { panel.hidden = panel.dataset.sizeGuidePanel !== tabName; });
    };
    setSizeGuideUnit(sizeGuideDialog?.dataset.defaultUnit === 'in' ? 'in' : 'cm');
    sizeGuideUnitButtons.forEach((button) => button.addEventListener('click', () => setSizeGuideUnit(button.dataset.sizeGuideUnit)));
    setSizeGuideTab('sizes');
    sizeGuideTabButtons.forEach((button, index) => {
      button.addEventListener('click', () => setSizeGuideTab(button.dataset.sizeGuideTab));
      button.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + sizeGuideTabButtons.length) % sizeGuideTabButtons.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % sizeGuideTabButtons.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = sizeGuideTabButtons.length - 1;
        const nextButton = sizeGuideTabButtons[nextIndex];
        if (nextButton) setSizeGuideTab(nextButton.dataset.sizeGuideTab, true);
      });
    });
    sizeGuideOpenButton?.addEventListener('click', () => {
      setSizeGuideTab('sizes');
      sizeGuideDialog?.showModal();
      window.requestAnimationFrame(() => sizeGuideTabButtons[0]?.focus());
    });
    sizeGuideCloseButton?.addEventListener('click', () => sizeGuideDialog?.close());
    sizeGuideDialog?.addEventListener('click', (event) => {
      if (event.target === sizeGuideDialog) sizeGuideDialog.close();
    });
    sizeGuideDialog?.addEventListener('close', () => sizeGuideOpenButton?.focus());
    let touchStartX = 0;
    mainMedia?.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0]?.clientX || 0; }, { passive: true });
    mainMedia?.addEventListener('touchend', (event) => {
      const touchEndX = event.changedTouches[0]?.clientX || 0;
      const distance = touchEndX - touchStartX;
      if (Math.abs(distance) < 45) return;
      activateImage(activeImage + (distance < 0 ? 1 : -1));
    }, { passive: true });

    const updateVariant = () => {
      const selected = groups.map((group) => {
        const checked = group.querySelector('[data-option-input]:checked');
        const value = checked?.value || '';
        const label = group.querySelector('[data-option-value]');
        if (label) label.textContent = value;
        return value;
      });
      const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));
      if (!variant) {
        if (submit) submit.disabled = true;
        if (submitText) submitText.textContent = 'Combinación no disponible';
        if (submitPrice) submitPrice.textContent = '';
        if (mobileSubmit) mobileSubmit.disabled = true;
        if (mobileSubmitText) mobileSubmitText.textContent = 'No disponible';
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = variant.price;
      if (mobilePrice) mobilePrice.textContent = variant.price;
      if (submit) submit.disabled = !variant.available;
      if (mobileSubmit) mobileSubmit.disabled = !variant.available;
      if (submitText) submitText.textContent = variant.available ? submitAvailableLabel : submitUnavailableLabel;
      if (mobileSubmitText) mobileSubmitText.textContent = variant.available ? mobileAvailableLabel : mobileUnavailableLabel;
      if (submitPrice) submitPrice.textContent = variant.available && submitShowsPrice ? `· ${variant.price}` : '';
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      if (variant.featured_image_id) {
        const featuredThumbnail = thumbnails.findIndex((thumbnail) => thumbnail.dataset.mediaId === variant.featured_image_id);
        if (featuredThumbnail >= 0) activateImage(featuredThumbnail);
      }
    };

    section.querySelectorAll('[data-option-input]').forEach((input) => input.addEventListener('change', updateVariant));

    const tabs = section.querySelectorAll('[role="tab"]');
    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item) => item.setAttribute('aria-selected', item === tab ? 'true' : 'false'));
        section.querySelectorAll('[role="tabpanel"]').forEach((panel) => {
          panel.hidden = panel.id !== tab.getAttribute('aria-controls');
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsokage-product-recommendations"]) return;
  try {
    
  document.querySelectorAll('[data-pk-product-recommendations]').forEach((section) => {
    if (section.dataset.recommendationsReady === 'true') return;
    section.dataset.recommendationsReady = 'true';

    const loadRecommendations = () => {
      const url = section.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const source = html.querySelector('[data-pk-product-recommendations]');
          if (source && source.innerHTML.trim()) {
            section.innerHTML = source.innerHTML;
          } else {
            section.remove();
          }
        })
        .catch(() => section.remove());
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        loadRecommendations();
      }, { rootMargin: '0px 0px 300px 0px' });
      observer.observe(section);
    } else {
      loadRecommendations();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pulsokage-slideshow"] && !Shopify.designMode) return;
  try {
    
  const initPulsokageSlideshows = (scope = document) => {
    scope.querySelectorAll('[data-pk-slideshow]').forEach((section) => {
      if (section.dataset.ready === 'true') return;
      section.dataset.ready = 'true';
      const slides = Array.from(section.querySelectorAll('[data-pk-slide]'));
      const dots = Array.from(section.querySelectorAll('[data-pk-dot]'));
      if (slides.length < 2) return;
      let active = 0;
      let timer;
      const show = (index) => {
        active = (index + slides.length) % slides.length;
        slides.forEach((slide, position) => { const selected = position === active; slide.classList.toggle('is-active', selected); slide.setAttribute('aria-hidden', selected ? 'false' : 'true'); });
        dots.forEach((dot, position) => dot.classList.toggle('is-active', position === active));
      };
      const restart = () => {
        window.clearInterval(timer);
        if (section.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = window.setInterval(() => show(active + 1), Number(section.dataset.speed) || 6000);
      };
      section.querySelector('[data-pk-prev]')?.addEventListener('click', () => { show(active - 1); restart(); });
      section.querySelector('[data-pk-next]')?.addEventListener('click', () => { show(active + 1); restart(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.pkDot)); restart(); }));
      section.addEventListener('mouseenter', () => window.clearInterval(timer));
      section.addEventListener('mouseleave', restart);
      restart();
    });
  };
  initPulsokageSlideshows();
  document.addEventListener('shopify:section:load', (event) => initPulsokageSlideshows(event.target));

  } catch(e) { console.error(e); }
})();
})();
